export default __webpack_public_path__ + "static/04.03-d597cebcfdfc6d6d30366c5ffe50ed82.png";